// extracted by mini-css-extract-plugin
export var compact = "_mx-2";
export var phoneFrame = "_mx-0";
export var phoneScreen = "_mx-1";